export const getAll = state => state.items;
